function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping-cart_1_",
  "data-name": "shopping-cart (1)",
  transform: "translate(-12.803 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3113",
  "data-name": "Group 3113",
  transform: "translate(24.507 40.294)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3112",
  "data-name": "Group 3112",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_357",
  "data-name": "Path 357",
  d: "M123.406,361.541a5.59,5.59,0,1,0,5.59,5.59A5.591,5.591,0,0,0,123.406,361.541Z",
  transform: "translate(-117.816 -361.541)",
  fill: "#ac1ede"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3115",
  "data-name": "Group 3115",
  transform: "translate(45.526 40.294)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3114",
  "data-name": "Group 3114"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_358",
  "data-name": "Path 358",
  d: "M312.01,361.541a5.59,5.59,0,1,0,5.59,5.59A5.591,5.591,0,0,0,312.01,361.541Z",
  transform: "translate(-306.42 -361.541)",
  fill: "#ac1ede"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3117",
  "data-name": "Group 3117",
  transform: "translate(12.803 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3116",
  "data-name": "Group 3116",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_359",
  "data-name": "Path 359",
  d: "M61.422,9.9H24.157l-.291-1.747A9.778,9.778,0,0,0,14.084,0h-.116a1.165,1.165,0,1,0,0,2.329h.116A7.515,7.515,0,0,1,21.6,8.5L25.38,30.978a6.948,6.948,0,0,0,6.929,5.706H55.6a1.165,1.165,0,1,0,0-2.329H32.309a4.583,4.583,0,0,1-4.6-3.843l-.64-3.727h26.26a4.681,4.681,0,0,0,4.483-3.377l1.863-6.521H25.38l-.408-2.329H60.315Z",
  transform: "translate(-12.803 0)",
  fill: "#ac1ede"
}))));

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.619,
    height: 51.473,
    viewBox: "0 0 48.619 51.473",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.a6c095c5.svg";
export { ForwardRef as ReactComponent };